import { useState } from "react";
import { motion } from "framer-motion";
import { LuLaptop, LuNewspaper } from "react-icons/lu";
import { MdWorkOutline } from "react-icons/md";
import { RiGraduationCapLine, RiCodeSSlashFill } from "react-icons/ri";
import { AiOutlineUser } from "react-icons/ai";
import Left from "./components/home/Left";
import About from "./components/about/About";
import ProfessionalExperience from "./components/professionalexperience/ProfessionalExperience";
import Education from "./components/education/Education";
import Skills from "./components/skills/Skills";
import Projects from "./components/projects/Projects";
import Contact from "./components/contact/Contact";
import Footer from "./components/home/Footer";
import Publications from "./components/publications/Publications";
import { FaRegEnvelope } from "react-icons/fa6";

const Home = () => {
  const [about, setAbout] = useState(true);
  const [professionalExperience, setProfessionalExperience] = useState(false);
  const [education, setEducation] = useState(false);
  const [publications, setPublications] = useState(false);
  const [skills, setSkills] = useState(false);
  const [projects, setProjects] = useState(false);
  const [contact, setContact] = useState(false);
  return (
    <div className="w-full lgl:w-[85%] h-full lgl:h-[85%] bg-transparent text-white z-50 flex items-start justify-between p-4 lgl:p-0 gap-0">
      <div className="w-full lgl:w-[96%] h-[94%] flex flex-col gap-6 lgl:gap-6 lgl:flex-col items-center">
        <div className="w-full lgl:w-[96%] h-full flex flex-col gap-4 lgl:flex-row items-center">

          <Left />
          <motion.div
            initial={{ x: 120, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.8 }}
            className="w-full lgl:w-8/12 h-full lg:h-[750px] bg-bodyColor rounded-2xl flex justify-center items-center">
            <div className="w-full h-full lgl:hidden bg-transparent rounded-2xl flex flex-col gap-6">
              <About />
              <ProfessionalExperience />
              <Education />
              <Publications />
              <Skills />
              <Projects />
              <Contact />
              <Footer />
            </div>
            <div className="w-full h-[96%] hidden lgl:block overflow-y-scroll scrollbar-thin scrollbar-thumb-[#646464] scrollbar-track-transparent">
              {about && (
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 0.5 }}
                >
                  <About />
                </motion.div>
              )}

              {professionalExperience && (
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 0.5 }}
                >
                  <ProfessionalExperience />
                </motion.div>
              )}
              {education && (
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 0.5 }}
                >
                  <Education />
                </motion.div>
              )}
              {publications && (
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 0.5 }}
                >
                  <Publications />
                </motion.div>
              )}
              {skills && (
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 0.5 }}
                >
                  <Skills />
                </motion.div>
              )}
              {projects && (
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 0.5 }}
                >
                  <Projects />
                </motion.div>
              )}
              {contact && (
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 0.5 }}
                >
                  <Contact />
                </motion.div>
              )}
            </div>
          </motion.div>
        </div>
        <div className="w-2/5 h-96 bg-transparent hidden lgl:flex flex-col">
          <motion.div
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8 }}
          >
            <div className="w-full h-12 bg-bodyColor rounded-3xl flex flex-row items-center justify-between py-7">
              <span
                onClick={() =>
                  setAbout(true) &
                  setProfessionalExperience(false) &
                  setEducation(false) &
                  setPublications(false) &
                  setSkills(false) &
                  setProjects(false) &
                  setContact(false)
                }
                className={`${about
                  ? "text-designColor"
                  : "w-full h-6 text-textColor text-2xl flex items-center justify-center hover:text-designColor duration-300 cursor-pointer relative group"
                  } w-full h-6 text-xl flex items-center justify-center hover:text-designColor duration-300 cursor-pointer relative group`}
              >
                <AiOutlineUser size={25} />
                <span className=" text-black text-center font-medium text-xs uppercase bg-designColor px-4 py-[1px] rounded-xl absolute translate-y-8 group-hover:-translate-y-12 opacity-0 group-hover:opacity-100 transition-all duration-300 z-20">
                  About
                </span>
              </span>
              <span
                onClick={() =>
                  setAbout(false) &
                  setProfessionalExperience(true) &
                  setEducation(false) &
                  setPublications(false) &
                  setSkills(false) &
                  setProjects(false) &
                  setContact(false)
                }
                className={`${professionalExperience
                  ? "text-designColor"
                  : "w-full h-6 text-textColor text-2xl flex items-center justify-center hover:text-designColor duration-300 cursor-pointer relative group"
                  } w-full h-6 text-2xl flex items-center justify-center hover:text-designColor duration-300 cursor-pointer relative group`}
              >
                <MdWorkOutline />
                <span className=" text-black text-center font-medium text-xs uppercase bg-designColor px-4 py-[1px] rounded-xl absolute group-hover:-translate-y-12 opacity-0 group-hover:opacity-100 transition-all duration-300 z-20">
                  Professional Experience
                </span>
              </span>
              <span
                onClick={() =>
                  setAbout(false) &
                  setProfessionalExperience(false) &
                  setEducation(true) &
                  setPublications(false) &
                  setSkills(false) &
                  setProjects(false) &
                  setContact(false)
                }
                className={`${education
                  ? "text-designColor"
                  : "w-full h-6 text-textColor text-2xl flex items-center justify-center hover:text-designColor duration-300 cursor-pointer relative group"
                  } w-full h-6 text-2xl flex items-center justify-center hover:text-designColor duration-300 cursor-pointer relative group`}
              >
                <RiGraduationCapLine />
                <span className="text-black text-center font-medium text-xs uppercase bg-designColor px-4 py-[1px] rounded-xl absolute translate-y-8 group-hover:-translate-y-12 opacity-0 group-hover:opacity-100 transition-all duration-300 z-20">
                  Education, Training & Certificates
                </span>
              </span>
              <span
                onClick={() =>
                  setAbout(false) &
                  setProfessionalExperience(false) &
                  setEducation(false) &
                  setPublications(true) &
                  setSkills(false) &
                  setProjects(false) &
                  setContact(false)
                }
                className={`${publications
                  ? "text-designColor"
                  : "w-full h-6 text-textColor text-2xl flex items-center justify-center hover:text-designColor duration-300 cursor-pointer relative group"
                  } w-full h-6 text-2xl flex items-center justify-center hover:text-designColor duration-300 cursor-pointer relative group`}
              >
                <LuNewspaper size={22} />
                <span className="text-black text-center font-medium text-xs uppercase bg-designColor px-4 py-[1px] rounded-xl absolute translate-y-8 group-hover:-translate-y-12 opacity-0 group-hover:opacity-100 transition-all duration-300 z-20">
                  Publications
                </span>
              </span>
              <span
                onClick={() =>
                  setAbout(false) &
                  setProfessionalExperience(false) &
                  setEducation(false) &
                  setPublications(false) &
                  setSkills(true) &
                  setProjects(false) &
                  setContact(false)
                }
                className={`${skills
                  ? "text-designColor"
                  : "w-full h-6 text-textColor text-2xl flex items-center justify-center hover:text-designColor duration-300 cursor-pointer relative group"
                  } w-full h-6 text-2xl flex items-center justify-center hover:text-designColor duration-300 cursor-pointer relative group`}
              >
                <RiCodeSSlashFill size={25} />
                <span className="text-black text-center font-medium text-xs uppercase bg-designColor px-4 py-[1px] rounded-xl absolute translate-y-8 group-hover:-translate-y-12 opacity-0 group-hover:opacity-100 transition-all duration-300 z-20">
                  Skills
                </span>
              </span>
              <span
                onClick={() =>
                  setAbout(false) &
                  setProfessionalExperience(false) &
                  setEducation(false) &
                  setPublications(false) &
                  setSkills(false) &
                  setProjects(true) &
                  setContact(false)
                }
                className={`${projects
                  ? "text-designColor"
                  : "w-full h-6 text-textColor text-2xl flex items-center justify-center hover:text-designColor duration-300 cursor-pointer relative group"
                  } w-full h-6 text-2xl flex items-center justify-center hover:text-designColor duration-300 cursor-pointer relative group`}
              >
                <LuLaptop />
                <span className="text-black text-center font-medium text-xs uppercase bg-designColor px-4 py-[1px] rounded-xl absolute translate-y-8 group-hover:-translate-y-12 opacity-0 group-hover:opacity-100 transition-all duration-300 z-20">
                  Projects
                </span>
              </span>
              <span
                onClick={() =>
                  setAbout(false) &
                  setProfessionalExperience(false) &
                  setEducation(false) &
                  setPublications(false) &
                  setSkills(false) &
                  setProjects(false) &
                  setContact(true)
                }
                className={`${contact
                  ? "text-designColor"
                  : "w-full h-6 text-textColor text-2xl flex items-center justify-center hover:text-designColor duration-300 cursor-pointer relative group"
                  } w-full h-6 text-xl flex items-center justify-center hover:text-designColor duration-300 cursor-pointer relative group`}
              >
                <FaRegEnvelope size={22} />
                <span className="text-black text-center font-medium text-xs uppercase bg-designColor px-4 py-[1px] rounded-xl absolute translate-y-8 group-hover:-translate-y-12 opacity-0 group-hover:opacity-100 transition-all duration-300 z-20">
                  Contact
                </span>
              </span>
            </div>
          </motion.div>
        </div>
      </div>
    </div >
  );
};

export default Home;